import { TeaserType } from '../../../domain/teaser/TeaserType.ts';
import { PointsInfoBannerType } from '../../../domain/points-info-banner/PointsInfoBannerType.ts';
import type { PointsInfoBannerContent } from '../../../domain/points-info-banner/PointsInfoBannerContent.ts';
import type { TeaserContent } from '../../../domain/teaser/TeaserContent.ts';
import  { FreeShippingBannerType } from '../../../domain/free-shipping-banner/FreeShippingBannerType.ts';

const contextEndpoint = '/up-teaserui/gateway/detailViewInfoTeaserContext?variationId=';

const NO_CONTENT_RESPONSE = {
	teaserType: TeaserType.NO_CONTENT,
	pointsInfoBannerType: PointsInfoBannerType.NO_CONTENT,
	freeShippingBannerType: FreeShippingBannerType.NO_CONTENT,
	showBoosterCampaignRedesign: false
}

export type DetailViewInfoTeaserContext = {
	teaserType: TeaserType,
	teaserContent?: TeaserContent,
	pointsInfoBannerType: PointsInfoBannerType,
	pointsInfoBannerContent?: PointsInfoBannerContent,
	freeShippingBannerType: FreeShippingBannerType,
	showBoosterCampaignRedesign: boolean,
}

export async function getTeaserAndPointsInfoBannerContext(variationId: string, benefitId?: string): Promise<DetailViewInfoTeaserContext> {
	let url = contextEndpoint + variationId;
	if (benefitId !== undefined) {
		url += `&benefitId=${benefitId}`;
	}
	try {
		const response = await fetch(url, {
			credentials: 'include',
			method: 'GET',
			headers: { 'Content-Type': 'application/json' }
		});
		if (response.status === 200) {
			return response.json();
		} else {
			return Promise.resolve(NO_CONTENT_RESPONSE);
		}
	} catch {
		return Promise.resolve(NO_CONTENT_RESPONSE);
	}
}
